export default __webpack_public_path__ + "static/media/boot.2aabee89.mp3";